import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import {
    commonMenuItems,
    userAdminMenuItems,
    groupAdminMenuItems,
    orgAdminMenuItems,
    serverAdminMenuItems,
    rootAdminMenuItems
} from '../MenuItems';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const [manageOrganizationId, setManageOrganizationId] = useState(null);

    const getManageOrganizationId = () => {
        setManageOrganizationId(JSON.parse(localStorage.getItem('manageOrganization'))?.orgid);
    };

    useEffect(() => {
        getManageOrganizationId();
    }, []);

    let menuItems;
    if (userInfo.admin_permissions.root_admin) {
        if (manageOrganizationId == null) {
            menuItems = rootAdminMenuItems;
        } else {
            menuItems = serverAdminMenuItems;
        }
    } else if (userInfo.admin_permissions.server_admin) {
        menuItems = serverAdminMenuItems;
    } else if (userInfo.admin_permissions.org_admin) {
        menuItems = orgAdminMenuItems;
    } else if (userInfo.admin_permissions.group_admin) {
        menuItems = groupAdminMenuItems;
    } else if (userInfo.admin_permissions.user_admin) {
        menuItems = userAdminMenuItems;
    } else {
        menuItems = commonMenuItems;
    }
    const navItems = menuItems.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
